import constants from '@/app-configs/constants'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/Settings.vue'),
    meta: {
      pageTitle: 'DEBTIA_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_SETTINGS',
          active: true,
        },
      ],
      action: 'settings',
      resource: 'settings',
    },
  },
  {
    path: '/translations',
    name: 'translations',
    component: () => import('@/views/translations/list/Translations.vue'),
    meta: {
      pageTitle: 'Translations',
      breadcrumb: [
        {
          text: 'Translations',
          active: true,
        },
      ],
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
    },
  },
  {
    path: '/payment-methods/list',
    name: 'payment-methods-list',
    component: () => import('@/views/payment-methods/payment-methods-list/PaymentMethodsList.vue'),
    meta: {
      pageTitle: 'DEBTIA_PAYMENT_METHODS',
      breadcrumb: [
        {
          text: 'DEBTIA_PAYMENT_METHODS',
          active: true,
        },
      ],

    },
  },
  {
    path: '/translations/edit/:id',
    name: 'edit-translation',
    component: () => import('@/views/translations/edit/TranslationEdit.vue'),
    meta: {
      action: constants.action.permissionUserEdit,
      resource: constants.resource.user,
    },
  },
  {
    path: '/payment-methods/edit/:id',
    name: 'payment-methods-edit',
    component: () => import('@/views/payment-methods/payment-methods-edit/PaymentMethodEdit.vue'),
    meta: {
      action: constants.action.permissionPaymentMethodEdit,
      resource: constants.resource.paymentMethod,
    },
  },
  {
    path: '/payment-methods/add',
    name: 'payment-methods-add',
    component: () => import('@/views/payment-methods/Add.vue'),
    meta: {
      title: 'add payment method',
      action: constants.action.permissionPaymentMethodAdd,
      resource: constants.resource.paymentMethod,
    },
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import('@/views/roles/Roles.vue'),
    meta: {
      pageTitle: 'DEBTIA_ROLE_MANAGEMENT',
      breadcrumb: [
        {
          text: 'DEBTIA_ROLE_MANAGEMENT',
          active: true,
        },
      ],
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
    },
  },
]
